import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
import { variant } from '@styled-system/variant';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('ProductCardContainer')(({ backgroundColor, padding, minHeight }) =>
  css({
    backgroundColor: backgroundColor || 'white',
    borderRadius: '3px',
    padding,
    m: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    minHeight,
    border: '1px solid',
    borderColor: 'grey.2',
  }),
);

themeStyles.addBaseStyles('TitleCopy')(({ alignment, styles, theme }) =>
  css({
    display: 'inline-block',
    width: '100%',
    fontFamily: 'bold',
    fontSize: ['20px', '20px', '24px'],
    lineHeight: ['24px', '24px', '28px'],
    textAlign: alignment,
    ...styles,
    '&:focus-visible': {
      outline: `${theme.borders[3]} ${theme.colors.aodaFocused}`,
      outlineOffset: '-3px',
    },
  }),
);

themeStyles.addBaseStyles('ModelCodeCopy')(({ alignment, isBold }) =>
  css({
    fontFamily: isBold ? 'bold' : 'default',
    textAlign: alignment,
    color: 'grey.0',
  }),
);

themeStyles.addBaseStyles('SubTitleCopy')(({ alignment, isBold }) =>
  css({
    fontFamily: isBold ? 'bold' : 'default',
    fontSize: '14px',
    lineHeight: '24px',
    textAlign: alignment,
    my: 'xs',
  }),
);

themeStyles.addBaseStyles('DriveRangeWrapper')(({ theme }) =>
  css({
    display: 'flex',
    padding: '0px 12px 4px 0px',
    gap: 'xxs',
    borderBottom: `${theme.borders[1]} ${theme.colors.grey[2]}`,
    mb: 'xs',
  }),
);

themeStyles.addBaseStyles('PriceDivider')(
  css({
    display: 'block',
    width: '100%',
    border: 0,
    height: '1px',
    backgroundColor: 'grey.2',
  }),
);

themeStyles.addBaseStyles('ImageNotFoundWrapper')(
  css({
    height: ['123px', '123px', '135px'],
    width: '100%',
    background: 'lightGray',
    maxWidth: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
);

themeStyles.addBaseStyles('ImageNotFoundCopy')(
  css({
    fontSize: ['l', 'l', 'xl'],
    lineHeight: 'default',
    fontFamily: 'bold',
    color: 'grey.0',
  }),
);

themeStyles.addBaseStyles('CardLink')(({ theme }) =>
  css({
    mb: 'xxs',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none',
    },
    '&:focus-visible': {
      outline: `${theme.borders[3]} ${theme.colors.aodaFocused}`,
      outlineOffset: '-3px',
    },
  }),
);

themeStyles.addBaseStyles('CardImage')(({ theme }) =>
  css({
    minHeight: '140px',
    mb: 'm',
    '&:focus-visible': {
      outline: `${theme.borders[3]} ${theme.colors.aodaFocused}`,
    },
  }),
);

themeStyles.addBaseStyles('UniCardWrapper')(
  ({ minHeight }) =>
    css({
      height: 'auto',
      minHeight,
      borderRadius: '3px',
    }),
  variant({
    prop: 'variant',
    variants: {
      hasShadow: {
        boxShadow: '0px 2px 16px 0px rgba(0, 0, 0, 0.10);',
      },
      noShadow: {
        boxShadow: 'none',
      },
    },
  }),
);

themeStyles.addBaseStyles('CTAWrapper')(({ styles }) =>
  css({
    marginTop: 'auto',
    paddingTop: 's',
    ...styles,
    a: {
      width: '100%',
    },
  }),
);

themeStyles.addBaseStyles('StyledButton')(({ theme }) =>
  css({
    '&:focus-visible': {
      outline: `${theme.borders[3]} ${theme.colors.aodaFocused}`,
    },
  }),
);

themeStyles.addBaseStyles('DriveRangeContainer')(
  css({
    height: '32px',
  }),
);

themeStyles.addBaseStyles('ImageContainer')(
  css({
    width: 'fit-content',
    margin: '0 auto',
  }),
);

export default themeStyles;
